import {create} from 'humane-js';

export const notify = create({ timeout: 2000, baseCls: 'humane-jackedup' });
export const  error = create({ timeout: 3000, baseCls: 'humane-jackedup', addnCls: 'humane-jackedup-error' });
